import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group-child" }
const _hoisted_2 = { for: "password" }
const _hoisted_3 = { class: "t-input-group" }
const _hoisted_4 = ["placeholder", "value"]
const _hoisted_5 = {
  key: 0,
  class: "error-text",
  "data-qe-id": "email-error"
}

import { validateEmail } from '@/lib/emailRequirements'
import { EMail } from '@/model/EMail'
import { beforeInputIgnoreSpace, removeSpace } from '@/lib/utils'
import { Ref, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  validate?: boolean
  modelValue: EMail
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailInput',
  props: {
    validate: { type: Boolean },
    modelValue: {}
  },
  emits: ['update:modelValue', 'reset'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const { t } = useI18n()

const mail: Ref<EMail> = ref({
  value: '',
  valid: false,
  errorCode: undefined,
  pattern: false,
  length: false,
})

const enableMailValidation = ref(false)

watch(
  () => props.modelValue,
  (to: EMail) => {
    mail.value = to
  },
  { deep: true },
)

watch(
  () => props.validate,
  (to: boolean) => {
    enableMailValidation.value = to
  },
)

const validateMail = (event: Event) => {
  mail.value.value = removeSpace((event.target as HTMLInputElement).value)
  mail.value = validateEmail(mail.value.value)
  if (mail.value.value.length === 0 || mail.value.valid) {
    enableMailValidation.value = false
    emit('reset')
  }
  emit('update:modelValue', mail.value)
}

const beforeInput = (event: InputEvent) => {
  beforeInputIgnoreSpace(event)
}

const onMailBlur = () => {
  if (mail.value.value.length > 0) {
    enableMailValidation.value = true
    mail.value = validateEmail(mail.value.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)('form.label.email')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        autocomplete: "email",
        "data-qe-id": "email",
        type: "email",
        name: "email",
        placeholder: _unref(t)('form.placeholder.email'),
        onBeforeinput: beforeInput,
        value: mail.value.value,
        class: _normalizeClass(enableMailValidation.value && (!mail.value.valid || mail.value.errorCode) ? 'error' : ''),
        onBlur: onMailBlur,
        onInput: validateMail,
        maxlength: "100"
      }, null, 42, _hoisted_4)
    ]),
    (enableMailValidation.value && mail.value.errorCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)(`form.errors.${mail.value.errorCode}`)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})